import React from "react";
import { useTranslation } from "react-i18next";

import { ArrangedUseLimitsData } from "../../../models/featureUseLimits/FeatureUseLimitsData";
import Pagination from "../../Pagination";
import { IndividualSettingItem } from "../IndividualSettingItem";
import { IndividualSettingListHeader } from "../IndividualSettingListHeader/Index";
import ListTopBar from "../ListTopBar";
import "./styles.scss";

export interface IFunctionIndividualSettingListProps {
  arrangedUseLimits: ArrangedUseLimitsData[];
  filterFormData: any;
  totalCount: number;
  targetType: string;
  onChangeFilterFormData: (filterFormData: any) => void;
  onClickEdit: (useLimit: ArrangedUseLimitsData) => void;
  onClickFilter: () => void;
  onClickClearFilterCondition: () => void;
}

const FunctionIndividualSettingList: React.FunctionComponent<
  IFunctionIndividualSettingListProps
> = ({
  arrangedUseLimits,
  filterFormData,
  totalCount,
  targetType,
  onClickEdit,
  onClickFilter,
  onChangeFilterFormData,
  onClickClearFilterCondition,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`functionManagementPage.individualSettingList.${key}`);

  return (
    <div className="white-border-panel individual-setting-list">
      <div className="table-data table-data-grid-pc-only">
        <ListTopBar
          filterFormData={filterFormData}
          targetType={targetType}
          onChangeFilterFormData={(filterFormData: any) => {
            onChangeFilterFormData(filterFormData);
          }}
          onClickFilter={onClickFilter}
          onClickClearFilterCondition={onClickClearFilterCondition}
        />
        <IndividualSettingListHeader targetType={targetType} />
        {arrangedUseLimits.length === 0 && (
          <div className="no-data-message">{t("no_data_message")}</div>
        )}
        {arrangedUseLimits.map((item) => (
          <IndividualSettingItem
            key={item.target_id}
            arrangedUseLimits={item}
            onClickEdit={() => onClickEdit(item)}
          />
        ))}
      </div>

      <Pagination
        filterFormData={filterFormData}
        totalRowsNumber={totalCount}
        onChangeFilterFormData={(filterFormData: any) => {
          onChangeFilterFormData(filterFormData);
        }}
      />
    </div>
  );
};

export default FunctionIndividualSettingList;
